import {Component, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {TarefaService} from "../../../services/tarefa-service";
import {ToastrService} from "ngx-toastr";
import {ListaTarefa} from "../../../models/lista-tarefa";
import {DatePipe} from "@angular/common";
import {NovaComponent} from "../nova/nova.component";
import {Token} from "../../../../auth/models/token";
import {AuthService} from "../../../../auth/services/auth-service";
import {DetalhesComponent} from "../detalhes/detalhes.component";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {AtribuiTarefa} from "../../../models/atribui-tarefa";

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild(NovaComponent) filho: NovaComponent;
  @ViewChild(DetalhesComponent) detalhesComponent: DetalhesComponent;
  loading = true;
  public colunas = [`Id`, `Descrição`, 'Responsável', 'Tipo tarefa', 'Data Finalização Prevista','Data de Cadastro'];
  public linhas: any[] = [];
  public listaTarefas = new ListaTarefa();
  public listaTarefasPlanejamento = new ListaTarefa();
  public listaTarefasFazer = new ListaTarefa();
  public listaTarefasEmAndamento = new ListaTarefa();
  public listaTarefasVerificacao = new ListaTarefa();
  public listaTarefasFechada = new ListaTarefa();
  token: Token | undefined;

  constructor(private tarefaService: TarefaService,
              private tokenService: AuthService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {
    this.buscarLista();
    this.token = this.tokenService.AccessToken;

    this.route.queryParams.subscribe(params => {
      const detalheId = Number(params['detalheId']);
      if (detalheId) {
        // Abrir modal de detalhes automaticamente quando chamado com queryParam
        setTimeout(() => this.buscarDetalheTarefa(detalheId));
      }
    });
  }



  public showModalNovo(status?: number): void {
    this.filho.showModalNova(status);
  }

  public buscarDetalheTarefa(id: number){
    this.detalhesComponent.showModalDetalhes();
    this.detalhesComponent.buscarDetalhesTarefa(id);
  }

  public buscarLista(){
    this.loading = true;
    this.tarefaService.minhasTarefas().subscribe(response => {
      if(response.sucesso){
        this.listaTarefas = response.dados;
        this.listaTarefasPlanejamento.itens = this.listaTarefas.itens.filter(x => x.status == 0);
        this.listaTarefasFazer.itens = this.listaTarefas.itens.filter(x => x.status == 1);
        this.listaTarefasEmAndamento.itens = this.listaTarefas.itens.filter(x => x.status == 2);
        this.listaTarefasVerificacao.itens = this.listaTarefas.itens.filter(x => x.status == 3);
        this.listaTarefasFechada.itens = this.listaTarefas.itens.filter(x => x.status == 4);
      }
      this.loading = false;
    });
  }

  drop(event: CdkDragDrop<any[]>, novoStatus: number) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const tarefa = event.previousContainer.data[event.previousIndex];

      let atribuirModelo = new AtribuiTarefa();
      atribuirModelo.id = tarefa.id;
      atribuirModelo.status = novoStatus;
      atribuirModelo.responsavelId = 0; // Assume 0 ou o ID do responsável se disponível no item

      this.loading = true;
      this.tarefaService.alterarStatus(atribuirModelo).subscribe(response => {
        if(response.sucesso){
          this.toastr.success('Status modificado com sucesso');
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex,
          );
          tarefa.status = novoStatus;
        } else {
          this.toastr.error('Erro ao modificar status');
        }
        this.loading = false;
      }, error => {
        this.toastr.error('Erro ao conectar com o servidor');
        this.loading = false;
      });
    }
  }
}
